import client from "Libs/platform";

/**
 * Given an expiration date, verify if the token should be refreshed.
 *
 * @param {number} expirationDate access token expiration date in seconds
 * @returns {boolean} whether the token should be refreshed or not
 */
const shouldRefreshToken = (expirationDate: number) => {
  const currentDate = Math.round(new Date().getTime() / 1000.0);
  return expirationDate !== -1 && currentDate >= expirationDate;
};

/**
 * Gets the current access token, it automatically reauthenticates if the token
 * has expried.
 */
const getAccessToken = async () => {
  let accessToken = await client.getAccessToken();

  if (shouldRefreshToken(accessToken.expires)) {
    accessToken = await client.reAuthenticate();
  }

  return accessToken;
};

export default getAccessToken;
